import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { openAdmissionLoginForm, openTSDialog } from 'src/app/helpers/methods';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { admissionNumberRegex, openDefaultLoginDialog, openSignUpDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';

@Component({
  selector: 'app-jee',
  templateUrl: './jee.component.html',
  styleUrls: ['./jee.component.css']
})
export class JeeComponent implements OnInit, AfterViewInit {
  searchValue: any = '';
  grades: any = [];
  exams: any = [];
  streams: any = [];
  tenant:any = TenantConstant.tenant;
  portal: any = TenantConstant.portal;
  SCPlaceHolder: any = 'Phone Number';
  SCMaxLength: any = 10;
  sriChaitanyaStartForm!: FormGroup;
  customSriChaitanyaStartFormValid = true;
  signup = signup;
  openSignUpDialog = openSignUpDialog;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openAdmissionLoginForm = openAdmissionLoginForm;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  constructor(
  private dialog: MatDialog,
  public signUpService: SignupService,
  private gaService: GAnalyticsService,
  private fb:FormBuilder,
  private gradesService: BoardsService,
  public userService: UserService,
  ) {
    if(this.portal != 'SCORE') {
      this.SCPlaceHolder = 'Admission Number';
      this.SCMaxLength = 13;
    }
  }
  ngOnInit(): void {
    
    if(this.portal != 'SCORE') {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(admissionNumberRegex)]]
      })
    } else {
      this.sriChaitanyaStartForm = this.fb.group({
        admissionNumber: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]]
      })
    }
    
    if (this.tenant != 'srichaitanya') {
      this.gradesService.getGrades(this);
      this.gradesService.getTargetExams(this);
      this.gradesService.getStreams(this);
    }
  }
  ngAfterViewInit() {

  }
  openDialog(source) {
    this.openTSDialog({message: 'One more step and you are all set', source, phone: '', isJEE: true});
  }
  doSearch(value: string): void {
    this.searchValue = value;
  }

  ngOnDestroy(){
  }
}
